import auth from '@/modules/authorization/api';
import { toArray } from '@/utils';

/**
 * @typedef CheckStaffPermissionPayload
 * @property {string} action
 * @property {string} [page]
 * @property {string} [entity]
 * @property {string} [type]
 * @property {string} [id]
 * @property {string} [taxonomyId]
 */

/**
 * @typedef CheckStaffPermissionResponse
 * @property {string} action
 * @property {string} [page]
 * @property {string} [entity]
 * @property {string} [type]
 * @property {string} [id]
 * @property {string} [taxonomyId]
 * @property {boolean} granted
 */

/**
 * @param {CheckStaffPermissionPayload|CheckStaffPermissionResponse} payloadA
 * @param {CheckStaffPermissionPayload|CheckStaffPermissionResponse} payloadB
 * @return {boolean} whether the two payloads represents the same permission or not.
 */
function comparePermissionPayloads(payloadA, payloadB) {
  return Object.entries(payloadA)
    .filter(([key, value]) => !!value && key !== 'granted')
    .every(([key, value]) => (key in payloadB) && payloadB[key] === value);
}

export default {
  namespaced: true,
  actions: {
    async UPDATE_PERMISSIONS({ commit }, payload) {
      const permissions = await auth.query(toArray(payload));
      commit('SET_PERMISSIONS', permissions);
    },
    async ADD_PERMISSIONS({ state, commit }, payload) {
      // Only add new permissions
      const filteredPayload = payload.filter(permission => state.permissions.includes(permission));
      if (filteredPayload.length === 0) return;
      const permissions = await auth.query(filteredPayload);
      commit('ADD_PERMISSIONS', permissions);
    },
    async AUTHORIZE({ state, commit }, payload) {
      // Check if the permission is already stored in cache.
      let permission = state.permissions.find(item => comparePermissionPayloads(payload, item));
      if (!permission) {
        // If not exists fetch it
        const permissions = await auth.query([payload]);

        if (!Array.isArray(permissions)
          || permissions.length === 0
        ) {
          return false;
        }
        commit('ADD_PERMISSIONS', permissions);
        permission = permissions[0];
      }
      // Check for auth
      return permission.granted || false;
    },
  },
  mutations: {
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    ADD_PERMISSIONS: (state, permissions) => {
      state.permissions = [...state.permissions, ...permissions];
    },
  },
  state: {
    /** @var {CheckStaffPermissionResponse[]} */
    permissions: [],
  },
};
